export default function MeasurementTable({ data }) {
  return (
    <div className="bg-white p-4 shadow rounded-xl">
      <h3 className="font-bold mb-4">تاریخچه کامل اندازه‌ها</h3>

      <div className="overflow-x-auto">
        <table className="w-full text-sm text-right">
          <thead>
            <tr className="border-b bg-gray-50">
              <th className="p-2">تاریخ</th>
              <th className="p-2">کمر</th>
              <th className="p-2">باسن</th>
              <th className="p-2">سینه</th>
              <th className="p-2">بازو</th>
            </tr>
          </thead>

          <tbody>
            {data.map((m) => (
              <tr key={m._id} className="border-b hover:bg-gray-50">
                <td className="p-2">
                  {new Date(m.createdAt).toLocaleDateString('fa-IR')}
                </td>
                <td className="p-2">{m.waist ?? '-'}</td>
                <td className="p-2">{m.hips ?? '-'}</td>
                <td className="p-2">{m.chest ?? '-'}</td>
                <td className="p-2">{m.bicep ?? '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
